import React from 'react';

const YearChanger = ({active_year, changeActiveYear}) => {

  const years = [2010,2011,2012,2013,2014,2015,2016,2017,2018];

  const handleOnClick = (year) => {
    changeActiveYear(year)
  }

  const handleCrementClick = (type) => {
    let active_index = years.indexOf(active_year);
    let next_index;
    if (type === 'inc') {
      next_index = active_index + 1;
      if (next_index + 1 > years.length) next_index = 0;
    } else {
      next_index = active_index - 1;
      if (next_index < 0) next_index = years.length - 1;
    }
    changeActiveYear(years[next_index]);
  }

  return  (
    <div id="YearChanger" className="bg-light-gray tnum nav-shadow no-select">
      <div className="flex">
        {years.map((year) =>
          <div
            key={year}
            className={"YearItem pointer px1 py1 " + (active_year === year ? 'active' : '')}
            style={{padding: '0.5rem 0.65rem 0.55rem'}}
            onClick={handleOnClick.bind(this, year)}
          >
            {year}
          </div>)
        }
        <div
          className="center h5 no-select py1 hover-light-gray border-left pointer"
          style={{paddingTop: '0.65rem', width: '2.5rem'}}
          onClick={handleCrementClick.bind(this, 'dec')}
        >
          ◀
        </div>
        <div
          className="center h5 no-select hover-light-gray py1 border-left pointer"
          style={{paddingTop: '0.65rem', width: '2.5rem'}}
          onClick={handleCrementClick.bind(this, 'inc')}
        >
          ▶
        </div>
      </div>
    </div>
  )
}

export default YearChanger;


/** WEBPACK FOOTER **
 ** ./src/components/YearChanger.js
 **/